import { useMemo } from 'react';
import { get } from 'lodash';
import { IFavorite } from '../../../modules/types/selections';

interface IParams {
  favorite?: IFavorite;
  imageId?: string;
  commentCount: number;
  onCommentClick?: (imageId: string) => void;
}

export const useImageCardFavoritesIcons = ({
  favorite,
  imageId,
  commentCount,
  onCommentClick
}: IParams) =>
  useMemo(() => {
    const like = get(favorite, 'like', false);
    // Legacy comment: a single string on the selection favorite. It is NOT
    // migrated into the new comment entity - the two models run in parallel, and
    // the gallery only ever writes the new one, so a legacy string and a new
    // thread on the same tile are genuinely different comments.
    const legacyComment = get(favorite, 'comment', '');
    // The improved-comments badge is opt-in: the parent grid only supplies
    // onCommentClick when the newCommentsDesign flag is on.
    const showCommentBadge = Boolean(onCommentClick && imageId && commentCount > 0);

    return {
      like,
      legacyComment,
      showLegacyComment: Boolean(legacyComment),
      showCommentBadge,
      isEmpty: !favorite && !showCommentBadge
    };
  }, [favorite, imageId, commentCount, onCommentClick]);
